import React from 'react'

import '../BlogPost.css'

import blog4_1 from '../../../assets/blog/blog4/1.png'
import blog4_2 from '../../../assets/blog/blog4/2.jpeg'
import blog4_3 from '../../../assets/blog/blog4/3.png'
import blog4_4 from '../../../assets/blog/blog4/4.png'
import blog4_5 from '../../../assets/blog/blog4/5.png'
import blog4_6 from '../../../assets/blog/blog4/6.png'
import blog4_7 from '../../../assets/blog/blog4/7.png'
import blog4_8 from '../../../assets/blog/blog4/8.png'

function Post3() {
    return (
        <div className='blog-content-body'>
            <hr></hr>
            <br></br>
            <br></br>
            <div className='blog_title'><b>프롤로그</b></div>
            <div className='blog_subtitle'>강의 첫 인상</div>
            <div className='article'>
            <br></br>
            올해 2월 패스트캠퍼스에서 진행하는 플러스엑스 실무 마스터 패키지를 수강했다.<br></br>
            <br></br>
            <img className='content-img' src={blog4_1} alt="" />
            <br></br>
            <br></br>실무마스터 패키지는 UX 프로젝트기획 + UX 디자인 리서치 + UX 디자인 컨셉과 전략을 전부 들을 수 있는 패키지형태의 강의인데, 어짜피 다 듣게될거 가성비있게 빨리빨리 결제했다.
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <img className='content-img' src={blog4_3} alt="" />
            <img className='content-img' src={blog4_2} alt="" />
            <br></br><br></br><b>그랬더니 두둥!</b>
            <br></br>그냥 고민없이 나오자마자 결제하긴 했는데 선착순 100명안에 들을줄이야..역시 고민은 배송만 늦출뿐이다.
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>#1</b></div>
            <div className='blog_subtitle'>전반적인 경험</div>
             <div className='article'>
            <br></br><br></br><b>플러스엑스강의는 확실히 디자인 입문자, 초보자가 듣기에는 너무 앞서나가는 내용들이 많다.</b>
            <br></br>실무자 혹은 프리랜서, 디자인스튜디오를 타겟으로 한게 많이 느껴지고, 디자인의 일을 하면서 좀더 효율적으로 일하는 방식을 디테일하게, 꿀팁을 섞어가며 알려주는 핵심 요약집에 가깝다.
            <br></br><br></br><img className='content-img' src={blog4_4} alt="" />
            <br></br>
            <br></br><b>첫 강의부터 플러스엑스의 REP 제안 요청서 포멧을 설명한다.</b> 
            <br></br><span className='tip'>*:제안요청서는 밀도있는 커뮤니케이션을 위해 사용한다.</span>
            <br></br>
            <br></br>1. 제안 요청 배경 <span className='tip'>*:사업을 왜 시작하는지</span>
            <br></br>2. 회사 소개
            <br></br>3. 서비스 소개
            <br></br>4. 서비스 주요화면
            <br></br>5. 기능요건
            <br></br>6. 기간
            <br></br>7. 예산
            <br></br>8. 업무범위
            <br></br>9. 산출물 형태  <span className='tip'>*:확장자</span>
            <br></br>10. 회의 진행방식
            <br></br>11. 레퍼런스
            <br></br>
            <br></br>프로젝트의 효율적인 진행을 위한 이야기를 주로 다루는 UX프로젝트 기획파트는, 업무가 너무 많을때 훅훅 치기 좋은 꿀팁이 많다. <br></br>
            <br></br>
            <img className='content-img' src={blog4_5} alt="" />
            <br></br>
            <br></br><b>UX 디자인 리서치 파트는</b>
            <br></br>분석에 관한 내용을 주로 다루는데, 타 매체의 강의에 비해서 이론적으로 큰 차별점은 없지만, 예시를 다양하게 설명해서 현장감이 느껴지게 강의하는 편이다. 
            사용방법보다는 이걸 왜 사용하는지에 대한 원리를 깊게 파고든다. 이 강의의 경우는 실무자 분들 보다는, 학생 때 들으면 좋을듯 하다.  과제를 하긴 하는데 이걸 왜 해야하는지 잘 모르는채 그냥 쳐내기 바쁘니까 이런 원리를 깊게 알면 동기부여가 크게 되지 않을까? 하는 작은 추측이다.
            <br></br>
            <br></br><b>UX 디자인 컨셉과 전략파트는</b>
            <br></br>아이데이션 이론 뒤에 본격적으로 작업의 모습이 보이는 챕터다. 정말 내용을 꽉꽉담아 제일 알찬 챕터이다. 실제로 디자인된 사례를 보여주면서 디테일하게 설명하기 때문에 다른 챕터보다 이론이 적고 작업물 예시를 많이 보여준다.
            <br></br>
            <br></br>하지만 해당 챕터의 특징적인것이 좀 있는데, 앞선 챕터에서는 10분~20분 내지로 균등한 시간의 강의라면 여기 챕터는 8분~1시간.. 좀 강의들마다 소요시간이 들쑥날쑥해서 다른 챕터보다는 시간을 내서 들어야한다. 
            <br></br><span className='tip'>시간이 좀 있는 취준생 혹은 방학기간의 학생들이라면 들을 수는 있겠는데, 강의 수준은 실무자를 타겟으로 한 것 같고,,. 회사다니고 개인일정 쳐내면서 1시간이나 강의를 듣는건 많은 용기가 필요할듯..</span>
            <br></br>
            <img className='content-img' src={blog4_6} alt="" />
            <br></br>
            <br></br>학습을하고 머릿속으로 기억을 하는 시간을 염두하면 아예 스트레이트로 듣는게 좋긴 하겠지만, 개인적으로 1시간, 50분이나 걸리는 강의는 지루하게 느껴졌다. 
            <br></br><br></br><b>그냥 나의 집중력 문제라고 할 수 있지만 변명좀 해보겠다.</b>
            <br></br>마이크로소프트가 의뢰한 타임지 연구(2015년)에 따르면 평균적인 집중시간은 8초라고 한다. 대다수의 사용자들이 실제로 웹페이지에서 보내는 평균적인 시간이다
            <br></br>▼
            <br></br>출처링크: <a href="https://dohwan.tistory.com/1864" target={'_blank'}>티스토리</a>
            <br></br>
            <br></br>해당 챕터를 만들때 내용을 너무 꽉차게 담느라 욕심을 많이 내신것같다. 개인적으로 강의시간은 분리가 가능하다면 절반으로 해주었으면 좋겠다. 학습을 정리할때도 좋고 복습할때 거부감이 훨씬 덜 했을것같다.
            <br></br>
            <br></br>사실 플엑의 강의 핵심은 마무리의 Q&A이다.<span className='tip'>질의 응답이라기엔 플러스 엑스를 소개하는게 주력인 챕터이긴 했지만.</span> 첫 마디 "실력보다 태도가 중요하다" 이말이 참 와닿았다. 
            <br></br>
            <br></br>신입한테 중요한게 무엇이냐고 했을때 태도가 제일 중요하다는 이야기를 했는데, 신입만 해당되는 이야기는 아니라고 생각한다. 일을 하면 할수록 능숙해지고 마련이고, 실력이 쌓이면 쌓일수록 꼰대가 될 확률만 높아지지.. 경청하고, 배우고, 성장하고, 즐기려는 태도는 꾸준히 유지하기가 너무 어렵다고 생각한다.
                    클라이언트를 무조건 설득하는게 아닌 공감과 협의가 중요하다는 코멘트도 하는데, 나도 유의하고 조심해야지!
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>에필로그</b></div>
            <div className='blog_subtitle'>다음 강의는 BX</div><br></br>
            <div className='article'>
            <img className='content-img' src={blog4_7} alt="" />
            <br></br>
            <br></br><b>출시 하자마자 바로 결제하긴했다.​</b>
            <br></br>가격은 얼리버드였으나 40만원을 넘는다.<span className='tip'>허거덩허거덩허거덩허거덩</span><br></br>
            <br></br>
            <img className='content-img' src={blog4_8} alt="" />
            <br></br>강의 후기 이벤트로 10% 쿠폰을 받았는데 출혈이 있다.. 하지만 나만 듣긴 아까우니까 이렇게 강의를 추천해본다.
            <br></br>
            </div>
        </div>
    )
}

export default Post3
